export default __webpack_public_path__ + "src/assets/zapperLogo.f20ce82503aa2020a841e1a249e4a027.svg";